const hasValidProperty = (obj, properties) => {
    return properties.some((prop) => {
        return obj.hasOwnProperty(prop) && obj[prop]
    })
}

export {
    hasValidProperty
}
